import { badges } from 'common'
import { LONG_DASH } from 'constants/index'

const ACHIEVEMENT_USER_LEVELS = [
  { level: 'wen_moon', name: 'Wen Moon', icon: badges.wen_moon_badge, color: 'hsl(200,74%,57%)' },
  { level: 'doge_walker', name: 'Doge Walker', icon: badges.doge_walker_badge, color: 'hsl(357,85%,65%)' },
  { level: 'zk_shark', name: 'ZK Shark', icon: badges.zk_shark_badge, color: 'hsl(213,100%,691)' },
  { level: 'bit_farmer', name: 'Bit Farmer', icon: badges.bit_farmer_badge, color: 'hsl(160,98%,32%)' },
  { level: 's_coin_sniper', name: 'Shitcoin Sniper', icon: badges.shitcoin_sniper_badge, color: 'hsl(328,84%,66%)' },
  { level: 'giga_chad', name: 'Giga Chad', icon: badges.giga_chad_badge, color: 'hsl(6,95%,77%)' },
  { level: 'supreme_degen', name: 'Supreme Degen', icon: badges.supreme_degen_badge, color: 'hsl(85,59%,53%)' },
  { level: 'yolo_god', name: 'YOLO God', icon: badges.yolo_god_badge, color: 'hsl(215,100%,64%)' },
]

export const getAchievementLevelUIData = (level) =>
  ACHIEVEMENT_USER_LEVELS.find((achievement) => achievement.level === level) ?? {
    level: 'unknow',
    name: `${LONG_DASH} ${LONG_DASH}`,
    icon: null,
    color: null,
  }
